import { callApi } from '@/helpers/api';
import CONFIG from '@/config/global';

const { api: { HOST, GET_CHANNEL_BY_SLUG } } = CONFIG;

// Get a channel by it's slug - eg mind_soup
const getChannelBySlug = ({ slug, isServer = false }) => {
  return callApi({
    url: HOST(GET_CHANNEL_BY_SLUG) + GET_CHANNEL_BY_SLUG.replace(':channel_slug', slug),
    isServer
  });
};

export default getChannelBySlug;